module.exports = __webpack_public_path__ + "img/remen_product1.22c34763.png";